<template>
  <div>
    <van-nav-bar style="background-color: #42b983">
      <template #title>
        <span style="color: #ffffff">安全及特种作业模拟考试</span>
      </template>
      <template #left>
        <router-link to="/">
          <van-icon name="arrow-left" color="#ffffff"/>
          <span style="color: #ffffff">返回</span>
        </router-link>
      </template>
      <template #right>
        <router-link to="/">
          <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
        </router-link>
      </template>
    </van-nav-bar>

    <br>

    <van-row type="flex" justify="center">

      <van-col>
        <vue-qr :logoSrc="qr_logo" :text="qr_text" :size="300"></vue-qr>
      </van-col>


    </van-row>

    <van-row type="flex" justify="center">
      <van-col>
        将当前页面截图进行再选择发送给朋友
        <br><br>
        或长按上方二维码保存图片，然后分享
        <br><br>
        或点击左上角的...再选择发送给朋友
      </van-col>
    </van-row>


    <br>


  </div>
</template>

<script>
import vueQr from 'vue-qr'
import wx from "weixin-js-sdk";

export default {
  components: {
    vueQr
  },
  data() {
    return {
      qr_text: "",
      qr_logo: require("@/assets/logo.png"),

      organ_id: 0,
      user: {}
    };
  },
  created() {
    // this.wxConfig()
    this.getQrCode()
  },
  methods: {
    wxConfig() {
      console.log("window.location.href:"+window.location.href)
      this.$http.post("/wechat/js_config", {url: window.location.href}).then(res => {

        if (200 !== res.data.code) {
          //
          return
        }
        console.log("开始")
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.data.app_id, // 必填，公众号的唯一标识
          timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.data.nonce_str, // 必填，生成签名的随机串
          signature: res.data.data.signature,// 必填，签名
          jsApiList: [
            'onMenuShareAppMessage',
            'updateTimelineShareData',
            'updateAppMessageShareData'
          ] // 必填，需要使用的JS接口列表
        });

        wx.ready(() => {   //需在用户可能点击分享按钮前就先调用
          wx.updateAppMessageShareData({
            title: '安全生产特种作业-学易通', // 分享标题
            desc: '安全生产特种作业-学易通', // 分享描述
            link: 'https://w.aqsctzzy.com/login?organ_id=' + this.organ_id, // 分享链接
            imgUrl: 'https://files.aqsctzzy.com/common/logo.png', // 分享图标
            success: function (res) {
              console.log("设置成功")
              console.log(res)
            }
          });
          wx.updateTimelineShareData({
            title: '安全生产特种作业-学易通', // 分享标题
            link: 'https://w.aqsctzzy.com/login?organ_id=' + this.organ_id, // 分享链接
            imgUrl: 'https://files.aqsctzzy.com/common/logo.png', // 分享图标
            success: function () {
              // 设置成功
            }
          })
        });


      });
    },
    getQrCode() {
      this.$http.get("/wechat/user/qr_code").then(res => {
        console.log(res.data);
        if (200 === res.data.code) {
          this.user = res.data.data.user
          this.qr_text = res.data.data.qr_code
          if (this.user.organ_id) {
            this.organ_id = this.user.organ_id

            //当当前用户存在机构的时候，确保其url上的机构是正确的，方便分享
            var query_organ_id = this.$route.query.organ_id
            if (undefined === query_organ_id || query_organ_id != this.organ_id) {
              window.location.href=window.location.pathname+"?organ_id="+this.organ_id;
            }
          }


        }
        this.wxConfig()
      });
    },
  }
}
</script>
